import { ControlPath, Qualifier } from "app/shared/model";

export class CommunicatorModel {
    public command: CommunicatorCommandsEnum;
    public path: Qualifier;
    public prop: string;

    public oldVal: any;
    public value: any;
    public isCalculationUpdate: boolean;

    get fullpath(): string {
        let clone = this.path.clone();
        clone.push(new ControlPath(this.prop))
        return clone.toString();
    }

    fullPathEquals($$qualifier: Qualifier, controlName: string) {
        return this.fullpath == $$qualifier.fullPathString(controlName);
    }

    constructor(command: CommunicatorCommandsEnum, prop: string, path: Qualifier, oldVal: any, value: any, isCalculationUpdate?: boolean) {
        this.command = command;
        this.prop = prop || '';
        this.path = new Qualifier(path?.toString());

        this.oldVal = oldVal;
        this.value = value;
        this.isCalculationUpdate = isCalculationUpdate;
    }
}

export class CommunicatorSetModel {
    public val: any;
    public delay: number;
    public isCalculationUpdate: boolean;

    constructor(val: any, delay: number, isCalculationUpdate?: boolean) {
        this.val = val;
        this.delay = delay;
        this.isCalculationUpdate = isCalculationUpdate;
    }
}

export enum CommunicatorCommandsEnum {
    set,
    deleteProperty,
    proxyObjectChanged
}

export class VisibilityChangeModel {
    visibilityId: string | number;
    flag: boolean;
    path: Qualifier;

    constructor(visibilityId: string | number, flag: boolean, path?: Qualifier) {
        this.visibilityId = visibilityId;
        this.flag = flag;
        this.path = path;
    }
}

export class MessageModel {
    id: string;
    addon: any;

    constructor(id: string, addon: any) {
        this.id = id;
        this.addon = addon;
    }
}
